// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .budget-page .input-wrapper {
  display: inline-block;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  flex-wrap: nowrap;
}
app-root .budget-page .input-wrapper > * {
  flex-grow: 0;
  flex-shrink: 0;
}
app-root .budget-page .input-wrapper em {
  display: inline-block;
  font-style: normal;
  padding: 0 0.6em;
  border-top: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid;
  height: calc(1.5em + 18px);
  line-height: calc(1.5em + 18px);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-color: var(--border-grey);
}
app-root .budget-page .input-wrapper .hb-input {
  position: relative;
}
app-root .budget-page .input-wrapper .hb-input > input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
app-root .budget-page .input-wrapper .hb-input .error-message {
  transform: translateX(-50%) translateY(-0.8rem);
  width: fit-content;
  position: absolute;
}
app-root .budget-page .input-wrapper .hb-input.show-validity .error-message {
  left: calc(50% - 1em);
  transform: translateY(0) translateX(-50%);
}
app-root .budget-page p.caption {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Views/FormSteps/Budget/BudgetInput.less"],"names":[],"mappings":"AAAA;EAGM,qBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAFN;AANA;EAWQ,YAAA;EACA,cAAA;AAFR;AAVA;EAgBQ,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,8BAAA;EACA,gCAAA;AAHR;AAvBA;EA6BQ,kBAAA;AAHR;AA1BA;EA+BU,yBAAA;EACA,4BAAA;AAFV;AA9BA;EAoCU,+CAAA;EACA,kBAAA;EACA,kBAAA;AAHV;AAKQ;EAEI,qBAAA;EACA,yCAAA;AAJZ;AAvCA;EAgDgB,gBAAA;AANhB","sourcesContent":["app-root {\n  .budget-page {\n    .input-wrapper {\n      display: inline-block;\n      white-space: nowrap;\n      display: inline-flex;\n      white-space: nowrap;\n      align-items: flex-start;\n      flex-wrap: nowrap;\n\n      > * {\n        flex-grow: 0;\n        flex-shrink: 0;\n      }\n\n      em {\n        display: inline-block;\n        font-style: normal;\n        padding: 0 0.6em;\n        border-top: 1px solid;\n        border-left: 1px solid;\n        border-bottom: 1px solid;\n        height: calc(1.5em + 18px);\n        line-height: calc(1.5em + 18px);\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n        border-color: var(--border-grey);\n      }\n      .hb-input {\n        position: relative;\n        > input {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        .error-message {\n          transform: translateX(-50%) translateY(-0.8rem);\n          width: fit-content;\n          position: absolute;\n        }\n        &.show-validity {\n          .error-message {\n            left: calc(50% - 1em);\n            transform: translateY(0) translateX(-50%);\n          }\n        }\n      }\n    }\n    p.caption { margin-top: 20px; }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
